import React, { ChangeEventHandler } from "react";

interface InputProps {
  label: string;
  placeholder?: string;
  value: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
}

const Input: React.FC<InputProps> = (props) => (
  <>
    <label className="text-xs">{props.label}</label>
    <input
      className="p-2 w-full bg-slate-200 border border-slate-400 rounded-lg text-sm mb-2"
      type="text"
      {...props}
    />
  </>
);

export default Input;
